import apiClient from "@/libs/axios";

export const state = {
    stats: [],
    latestVendors: [],
    latestAppointments: [],
};

export const mutations = {
    setStats: (state, data) => {
        state.stats = data.result;
    },
    setLatestVendors: (state, data) => {
        state.latestVendors = data.result.data;
    },
    setAppointments: (state, data) => {
        state.latestAppointments = data.result;
    },

    updateLatestAppointments: (state, data) => {
        state.latestAppointments = state.latestAppointments.filter((item) => item.id !== data.id)
    },

    updateLatestVendors: (state, data) => {
        state.latestVendors = state.latestVendors.filter((item) => item.id !== data.id)
    }
};

export const actions = {
    async getVendorDashboardStats({ commit }) {
        await apiClient
            .get(`api/v1/stats/my-stats`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setStats', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async getStats({ commit }) {

        await apiClient
            .get(`api/v1/admin/stats`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setStats', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async getLatestVendors({ commit }) {
        await apiClient
            .get(`api/v1/admin/latest-vendors`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setLatestVendors', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },

    async getLatestAppointments({ commit }) {
        commit('loadingStart', null, {root: true});
        await apiClient
            .post(`api/v1/admin/latest-appointments`)
            .then(response => {
                console.log(response.data)
                commit('setAppointments', response.data)
                commit('loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/app/loadingFinish', null, {root: true});
                throw error;
            },);
    },

    async getLatestVendorAppointments({ commit }) {
        await apiClient
            .get(`api/v1/appointments/vendor-latest-appointments`)
            .then(response => {
                console.log(response.data)
                commit('setAppointments', response.data)
            })
            .catch(error => {
                throw error;
            },);
    },

    async reject({ commit, dispatch }, data) {
        await apiClient
            .patch(`api/v1/appointments/reject`, {id: data.id, reject_note: data.reject_reason})
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateLatestAppointments', response.data.result);
                    dispatch('getVendorDashboardStats');
                }
            })
            .catch(error => {
                throw error;
            },);
    },

    async approve({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .patch(`api/v1/users/vendors/approve`, data)
            .then(response => {
                console.log(response.data.result)
                if (response.status === 201) {
                    commit('updateLatestVendors', response.data.result);
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});
    },
};

export const getters = {
    getStats(state) {
        return state.stats;
    },
    getLatestVendors(state) {
        return state.latestVendors;
    },
    getLatestAppointments(state) {
        return state.latestAppointments;
    },
};
